import React, {Fragment} from "react";
import htmlParser from "he";
import {capitalizeFirstCharacter, personalizeResponse} from "_helpers";
import moment from "moment-timezone";
import {metricsActions} from "_actions";
import {useDispatch} from "react-redux";
import CsatComponent from "./CsatComponent";
import {parseHtml} from "_helpers";
import styles from "./Utilities/Styles.module.css"

const MetricsConversation = ({message, pageFilter, nextMessage, csatList, msgSource}) => {
    const dispatch = useDispatch();
    const messageAuthor = message?.msgAuthor;
    const currentUser =  JSON.parse(localStorage.getItem('user'))
    const orgId = currentUser._embedded.organization.id;
    const zone_name =  moment.tz.guess();
    const timezone = moment.tz(zone_name).zoneAbbr();

    const dateCreated =  message?.dateCreatedFromSrc || message?.dateCreated;
    const nextMsgDateCreated = nextMessage?.dateCreatedFromSrc || nextMessage?.dateCreated
    const text = parseHtml(htmlParser.decode(personalizeResponse(message.text, messageAuthor, "", null)), msgSource, true, true);

    let showPresaleBtn;

    const setPreSaleValue = (messageId, orgId, preSaleValue) => {
        dispatch(metricsActions.setPreSaleValue({messageId, organization: orgId, preSaleValue}))
    };

    if (pageFilter === 'presale' && message?.presale != null)  {
        showPresaleBtn =
            <div className="sale-options">
                {message.presale &&
                     <Fragment>
                         <span className="selected-sale-option">Pre-sale</span>
                         <button className="preSaleBtn"
                                 onClick={() => setPreSaleValue(message.msgId, orgId, false)}>Other
                         </button>
                     </Fragment>
                }
                {!message.presale &&
                    <Fragment>
                        <button className="preSaleBtn"
                                onClick={() => setPreSaleValue(message.msgId, orgId, true)}>Pre-sale
                        </button>
                        <span className="selected-sale-option">Other</span>
                    </Fragment>
                }
            </div>
    }

    return(
        <Fragment>
            <div className={styles.conversationContainer}>
                <div className="md-msg-container">
                    <div className="conversation-item-container">
                        <div className="conversation-item-row">
                            <div className={styles.msgMetaDetails}>
                                <div className={styles.msgAuthor}>{messageAuthor}</div>
                                <div className={styles.metricsDetailDateTime}>
                                    <span className="metrics-detail-date">
                                        {capitalizeFirstCharacter(moment.utc(dateCreated).fromNow())}
                                        {` (${moment(dateCreated).format('MMMM Do YYYY HH:mm')} ${timezone})`}
                                    </span>
                                </div>
                            </div>
                            <div
                                className={`${styles["metricsDetailFullMsg"]} ${
                                     message.direction.toLowerCase() === "outgoing" ? styles.outgoingMsg : ""
                                }`}
                            >
                                {text}
                            </div>
                            {showPresaleBtn}
                        </div>
                    </div>
                </div>
                {csatList.filter(
                    item => (moment(item.csatDate).isSameOrAfter(moment(dateCreated)) && !nextMessage)
                    || (moment(item.csatDate).isSameOrAfter(moment(dateCreated)) && nextMessage &&
                        moment(item.csatDate).isBefore(moment(nextMsgDateCreated)))
                ).map(csatItem =>
                    <CsatComponent
                        key={csatItem.mmdId}
                        timezone={timezone}
                        mmdComment={csatItem.mmdComment}
                        unifiedScore={csatItem.mmdUnifiedScore}
                        csatDate={csatItem.csatDate}
                    />)
                }
            </div>
        </Fragment>
    )
}

export default MetricsConversation;

